import React, { useEffect } from "react";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import UserHeader from "../components/Header/UserHeader";
import Footer from "../components/Footer";
import { Token } from "../atom/atom";
import { useRecoilValue } from "recoil";

export default function Account(props) {
  const isAuthenticated = useRecoilValue(Token);
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/home");
    } else {
      navigate("/account");
    }
  }, []);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <UserHeader {...props} />
      <Container
        maxWidth="xl"
        sx={{
          paddingTop: "4rem",
          justifyContent: "flex-start",
          textAlign: "left",
        }}
      >
        <Grid container spacing={8}>
          <Grid item xs={12} sm={12} md={12}>
            <Typography
              variant="h1"
              sx={{ fontSize: { xs: "1.5rem", sm: "2rem", md: "3rem" } }}
            >
              Account
            </Typography>
          </Grid>
        </Grid>
      </Container>
      <Footer />
    </Box>
  );
}
